import React from "react";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import PageScaffold from "../../components/PageScaffold";
import { pageTitles } from "../../utils/paths";
import OrderFlowTester from "./OrderFlowTester";
import TestOrderForm from "./TestOrderForm";

const Index = () => {
  return (
    <PageScaffold title={pageTitles.testOrder} isHeaderVisible={false}>
      <Tabs variant="line" colorScheme="blue" size="sm" isLazy>
        <TabList px={4} bg="white" borderBottomWidth="1px" position="sticky" top={0} zIndex={2}>
          <Tab fontWeight="600">Order flow tester</Tab>
          <Tab fontWeight="600">
            Insert test order
            <Text as="span" ml={2} fontSize="10px" color="gray.400" fontWeight="400">
              legacy
            </Text>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel p={0}>
            <OrderFlowTester />
          </TabPanel>
          <TabPanel p={0}>
            <Box>
              <TestOrderForm />
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </PageScaffold>
  );
};

export default Index;
